import { LangCode } from '../hooks/useSpeechToText';

type SpeechLanguageConfig = {
  code: LangCode;
  label: string;
  dir: 'rtl' | 'ltr';
  messagePlaceholder: string;
  aiPlaceholder: (botName: string) => string;
  notePlaceholder: string;
};

const configs: SpeechLanguageConfig[] = [
  {
    code: 'ar-PS',
    label: 'AR',
    dir: 'rtl',
    messagePlaceholder: 'اكتب رسالة…',
    aiPlaceholder: (botName: string) => `اطلب من ${botName}…`,
    notePlaceholder: 'أضف ملاحظة جديدة…',
  },
  {
    code: 'he-IL',
    label: 'HE',
    dir: 'rtl',
    messagePlaceholder: 'כתוב הודעה…',
    aiPlaceholder: (botName: string) => `שאל את ${botName}…`,
    notePlaceholder: 'הוסף הערה חדשה...',
  },
  {
    code: 'en-US',
    label: 'EN',
    dir: 'ltr',
    messagePlaceholder: 'Write a message…',
    aiPlaceholder: (botName: string) => `Ask ${botName}…`,
    notePlaceholder: 'Add a new note…',
  },
];

const SPEECH_LANG_OPTIONS = configs;

const SPEECH_LANG_CONFIG = configs.reduce<Record<LangCode, SpeechLanguageConfig>>((acc, cfg) => {
  acc[cfg.code] = cfg;
  return acc;
}, {} as Record<LangCode, SpeechLanguageConfig>);

export { SPEECH_LANG_OPTIONS, SPEECH_LANG_CONFIG };
export type { SpeechLanguageConfig };
